// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__6Zv-6","list":"Footer_list__Xz2Uv","copyHint":"Footer_copyHint__F8dkg","version":"Footer_version__3vPsU"};